import time from '@/service/base/time';
import i18n from '@/i18n';
import store from '@/store';
import S_auditRecord from '@/service/api/v1/audit_record';
import S_auditRequest from '@/service/api/v1/audit_request';
import S_checklistRecord from '@/service/api/v1/checklist_record';
import H_common from '@/helpers/common';
import H_checklist from '@/helpers/checklist';
import H_auditRecord from '@/helpers/auditRecord';
import H_checklistRecord from '@/helpers/checklistRecord';
import H_systemClassMenu from '@/helpers/systemClassMenu';
import Spare_alertIndexTable from '@/spare/alert-index-table';
export default {
  getMergedSubclassesForChip(data, factorySystemClassRows = []) {
    return H_systemClassMenu.formatMultiSystemClassContentChips(
      {
        system_classes: data.system_classes,
        system_subclasses: data.system_subclasses,
        factory_system_classes: data.factory_system_classes,
        factory_system_subclasses: data.factory_system_subclasses,
      },
      { factorySystemClassRows },
    );
  },
  setChecklistData(data, factorySystemClassRows = []) {
    const { checkers, reviewers, updated_at: updatedAt } = data;
    const _checkers = H_checklist.setAnswerReviewRecord(checkers, 'answer');
    const _reviewers = H_checklist.setAnswerReviewRecord(reviewers, 'review');
    return [
      {
        title: i18n.t('領域'),
        type: 'chip',
        chip: this.getMergedSubclassesForChip(data, factorySystemClassRows),
      },
      {
        title: i18n.t('填表日期'),
        type: 'text',
        textContent: time.getTimeFormat(updatedAt, 'YYYY-MM-DD'),
      },
      {
        title: i18n.t('答題者'),
        type: 'avatars',
        avatars: _checkers,
      },
      {
        title: i18n.t('覆核者'),
        type: 'avatars',
        avatars: _reviewers,
      }
    ];
  },
  async getChecklistQues(data) {
    const riskSortFields = store.state.model.checklistRiskLevelList.filter(risk => risk.type === 'question' && risk.score != 20 && risk.score != 26);
    const recordId = data.payload.id;
    const answerRes = await S_checklistRecord.answerIndex(recordId);
    const quesList =  H_checklistRecord.setRecordQuesList(answerRes);
    const quesListSortByRisk = riskSortFields.map(risk => quesList.filter(ques => ques.answerRisk.code == risk.code));
    return {quesList, quesListSortByRisk};
  },
  setListData(list) {
    const _list = list.map((alertItem) => {
      return {
        id: alertItem.id,
        releaseTime: time.getTimeFormat(
          alertItem.created_at,
          'YYYY-MM-DD HH:mm:ss',
        ),
        result: {
          icon: 'icon-alert-filled',
          color: alertItem.level === 2 ? 'red' : 'yellow'
        },
        alertCondition: this.getAlertCondition(alertItem.solved_at),
        knockOverTime: alertItem.solved_at
          ? time.getTimeFormat(alertItem.solved_at, 'YYYY-MM-DD HH:mm:ss')
          : '',
        content: this.getAlertDataName(alertItem),
        taskCondition: this.getTaskCondition(alertItem),
      };
    });
    return _list;
  },
  getAlertCondition(time) {
    if (!time) {
      return { color: 'lightGray', text: i18n.t('未排除') };
    } else {
      return { color: 'darkGray', text: i18n.t('已排除') };
    }
  },
  getAlertDataName(data) {
    if (data.from === 'event') {
      const locale = store.state.stone_locale.selectingLocale.code;
      const eventTypeName = data.payload.event_type.locales && data.payload.event_type.locales[locale]
        ? data.payload.event_type.locales[locale].name
        : data.payload.event_type.name;
      return `[${i18n.t(eventTypeName)}]` + data.payload.name;
    } else if (data.from === 'exit_checklist') {
      const contractorName = data.payload.contractor
        ? data.payload.contractor.name
        : '';
      return `[${i18n.t('進場尚未復歸')}] ${contractorName}- ${
        data.payload.task_content
      }`;
    } else if (data.from === 'contractor_enter_record') {
      const contractorName = data.payload.contractor
        ? data.payload.contractor.name
        : '';
      return `[${i18n.t('進場尚未檢查')}] ${contractorName}- ${
        data.payload.task_content
      }`;
    } else if (data.from === 'contractor_license') {
      const contractorName = data.payload.contractor
        ? data.payload.contractor.name
        : '';
      return `[${i18n.t('承攬商資格到期')}] ${contractorName} 之${
        data.payload.name
      }`;
    } else if (data.from === 'license') {
      if (data.type === 'valid_end_date') {
        return `[${i18n.t('證照到期')}] ${data.payload.name}`;
      } else if (data.type === 'remind_date') {
        return `[${i18n.t('證照續辦提醒')}] ${data.payload.name}`;
      } else {
        return `[${i18n.t('證照法定展延期限')}] ${data.payload.name}`;
      }
    } else if (data.from === 'checklist_record') {
      return (
        `[${i18n.t('點檢')}] ` +
        data.payload.name +
        ` (${i18n.t('平均合規率')}
        ${data.payload.pass_rate}%) ${i18n.t('結果')}-` +
        this.getRecordResult(data.payload.risk_level)
      );
    } else if (data.from === 'audit_record') {
      return (
        `[${i18n.t('稽核')}] ` +
        data.payload.name +
        `${i18n.t('結果')} -` +
        this.getRecordResult(data.payload.risk_level)
      );
    } else {
      return i18n.t('警示名稱');
    }
  },
  getAlertTotalRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: this.getAlertDataName(item),
        status: {
          color: 'gray',
          text: i18n.t('未排除'),
        },
        date: time.getTimeFormat(item.created_at, 'YYYY-MM-DD HH:mm:ss'),
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/alert-content/${item.id}?from=dashboard`,
        },
      };
    });
    return _list;
  },
  getAlertAddRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: this.getAlertDataName(item),
        status: {
          color: 'gray',
          text: i18n.t('未排除'),
        },
        date: time.getTimeFormat(item.created_at, 'HH:mm'),
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/alert-content/${item.id}?from=dashboard`,
        },
      };
    });
    return _list;
  },
  getRecordResult(level) {
    if (Number(level) === 23) {
      return i18n.t('高風險');
    } else if (Number(level) === 22) {
      return i18n.t('中風險');
    } else if (Number(level) === 21) {
      return i18n.t('低風險');
    } else {
      return '';
    }
  },
  getTaskCondition(data) {
    const task = data.task;
    if (!task) {
      return { color: 'lightGray', text: i18n.t('未建立') };
    } else {
      if (!task.checked_at && !task.done_at) {
        return { color: 'yellow', text: i18n.t('進行中') };
      } else if (task.done_at && !task.checked_at) {
        return { color: 'orange', text: i18n.t('待審核') };
      } else {
        return { color: 'darkGray', text: i18n.t('已完成') };
      }
    }
  },
  async setAlertInfoList(data, currentFactory, factorySystemClassRows = []) {
    const _list = [];
    if (data.from === 'event') {
      const _infoList = {
        title: i18n.t('事件資訊'),
        type: 'infoList',
        infoListItem: this.getEventData(data, factorySystemClassRows),
      };
      _list.push(_infoList);
    } else if (data.from === 'exit_checklist') {
      const _infoList = {
        title: i18n.t('進場資訊'),
        type: 'infoList',
        infoListItem: this.getEnterData(data),
      };
      _list.push(_infoList);
    } else if (data.from === 'contractor_enter_record') {
      const _infoList = {
        title: i18n.t('進場資訊'),
        type: 'infoList',
        infoListItem: this.getEnterData(data),
      };
      _list.push(_infoList);
    } else if (data.from === 'contractor_license') {
      const _infoList = {
        title: i18n.t('資格證資訊'),
        type: 'infoList',
        infoListItem: this.getContractorLicenseData(data, factorySystemClassRows),
      };
      _list.push(_infoList);
    } else if (data.from === 'license') {
      const _infoList = {
        title: i18n.t('證照資訊'),
        type: 'infoList',
        infoListItem: this.getLicenseData(data, currentFactory, factorySystemClassRows),
      };
      _list.push(_infoList);
    } else if (data.from === 'checklist_record') {
      const recordContent = await S_checklistRecord.show(data.checklist_record.id);
      const _infoList = {
        title: i18n.t('點檢表資訊'),
        type: 'infoList',
        infoListItem: this.setChecklistData(recordContent, factorySystemClassRows),
      };
      _list.push(_infoList);
      const {quesList, quesListSortByRisk} = await this.getChecklistQues(data);
      const _quesList = {
        title: i18n.t('題目'),
        type: 'checklistQuesList',
        quesList,
        quesListSortByRisk,
      };
      _list.push(_quesList);
    } else if (data.from === 'audit_record') {
      const _infoList = {
        title: i18n.t('稽核表資訊'),
        type: 'infoList',
        infoListItem: this.getAuditData(data, factorySystemClassRows),
      };
      _list.push(_infoList);
      const _quesList = {
        title: i18n.t('題目'),
        type: 'quesList',
        quesList: [],
      };
      _quesList.quesList = await this.getAuditQues(data);
      _list.push(_quesList);
    }
    return _list;
  },
  getEventData(data, factorySystemClassRows = []) {
    const _dataList = [];
    const _eventSubClasses = {
      title: i18n.t('領域'),
      type: 'chip',
      chip: this.getMergedSubclassesForChip(data, factorySystemClassRows),
    };
    _dataList.push(_eventSubClasses);
    const _infoList = {
      title: i18n.t('發生日期'),
      type: 'text',
      textContent: time.getTimeFormat(data.payload.occur_at, 'YYYY-MM-DD'),
    };
    _dataList.push(_infoList);
    const _eventTime = {
      title: i18n.t('發生時間'),
      type: 'text',
      textContent: time.getTimeFormat(data.payload.occur_at, 'HH:mm'),
    };
    _dataList.push(_eventTime);
    const _eventRemark = {
      title: i18n.t('說明'),
      type: 'text',
      textContent: data.payload.remark,
    };
    _dataList.push(_eventRemark);
    const _eventOwner = {
      title: i18n.t('負責人'),
      type: 'avatars',
      avatars: [],
    };
    _eventOwner.avatars.push(data.payload.owner);
    _dataList.push(_eventOwner);
    return _dataList;
  },
  getEnterData(data) {
    const _dataList = [];
    const _enterDate = {
      title: i18n.t('進場日期'),
      type: 'text',
      textContent: time.getTimeFormat(data.payload.enter_start_date, 'YYYY-MM-DD'),
    };
    _dataList.push(_enterDate);
    const _enterTime = {
      title: i18n.t('進場時間'),
      type: 'text',
      textContent:
        time.getTimeFormat(data.payload.enter_start_time, 'HH:mm') +
        '-' +
        time.getTimeFormat(data.payload.enter_end_time, 'HH:mm'),
    };
    _dataList.push(_enterTime);
    const _contractor = {
      title: i18n.t('承攬商'),
      type: 'text',
      textContent: data.payload.contractor ? data.payload.contractor.name : '',
    };
    _dataList.push(_contractor);
    const _taskContent = {
      title: i18n.t('工作內容'),
      type: 'text',
      textContent: data.payload.task_content,
    };
    _dataList.push(_taskContent);
    const _taskLocation = {
      title: i18n.t('工作地點'),
      type: 'text',
      textContent: data.payload.operate_location,
    };
    _dataList.push(_taskLocation);
    const _eventOwner = {
      title: i18n.t('負責人'),
      type: 'avatars',
      avatars: [],
    };
    _eventOwner.avatars.push(data.payload.owner);
    _dataList.push(_eventOwner);

    return _dataList;
  },
  getContractorLicenseData(data, factorySystemClassRows = []) {
    const _dataList = [];
    const _licenseName = {
      title: i18n.t('名稱'),
      type: 'text',
      textContent: data.payload.name,
    };
    _dataList.push(_licenseName);
    const _licenseSubClasses = {
      title: i18n.t('領域'),
      type: 'chip',
      chip: this.getMergedSubclassesForChip(data, factorySystemClassRows),
    };
    _dataList.push(_licenseSubClasses);
    const _licenseType = {
      title: i18n.t('類型'),
      type: 'text',
      textContent: data.payload.license_template.name,
    };
    _dataList.push(_licenseType);
    const _licenseDuration = {
      title: i18n.t('有效起迄'),
      type: 'text',
      textContent:
        time.getTimeFormat(
          data.payload.last_version.valid_start_date,
          'YYYY-MM-DD',
        ) +
        '~' +
        time.getTimeFormat(
          data.payload.last_version.valid_end_date,
          'YYYY-MM-DD',
        ),
    };
    _dataList.push(_licenseDuration);
    const _licenseRemind = {
      title: i18n.t('續辦提醒'),
      type: 'text',
      textContent: time.getTimeFormat(
        data.payload.last_version.remind_date,
        'YYYY-MM-DD',
      ),
    };
    _dataList.push(_licenseRemind);
    const _licenseTaker = {
      title: i18n.t('持有人'),
      type: 'text',
      textContent: data.payload.last_version.taker_text
        ? data.payload.last_version.taker_text
        : data.payload.contractor.name,
    };
    _dataList.push(_licenseTaker);
    return _dataList;
  },
  getLicenseData(data, currentFactory, factorySystemClassRows = []) {
    const _dataList = [];
    const _licenseSubClasses = {
      title: i18n.t('領域'),
      type: 'chip',
      chip: this.getMergedSubclassesForChip(data, factorySystemClassRows),
    };
    _dataList.push(_licenseSubClasses);
    const _licenseName = {
      title: i18n.t('名稱'),
      type: 'text',
      textContent: data.payload.name,
    };
    _dataList.push(_licenseName);
    const _licenseNumber = {
      title: i18n.t('證號'),
      type: 'text',
      textContent: data.payload.last_version.license_number
        ? data.payload.last_version.license_number.name
        : '',
    };
    _dataList.push(_licenseNumber);
    const _licenseType = {
      title: data.payload.last_version.taker ? i18n.t('持有人') : i18n.t('持有單位'),
      type: 'text',
      textContent: data.payload.last_version.taker
        ? data.payload.last_version.taker.name
        : currentFactory.name,
    };
    _dataList.push(_licenseType);
    const _licenseDuration = {
      title: i18n.t('有效起迄'),
      type: 'text',
      textContent:
        time.getTimeFormat(
          data.payload.last_version.valid_start_date,
          'YYYY-MM-DD',
        ) +
        '-' +
        time.getTimeFormat(
          data.payload.last_version.valid_end_date,
          'YYYY-MM-DD',
        ),
    };
    _dataList.push(_licenseDuration);
    const _licenseRemind = {
      title: i18n.t('續辦提醒'),
      type: 'text',
      textContent: time.getTimeFormat(
        data.payload.last_version.remind_date,
        'YYYY-MM-DD',
      ),
    };
    _dataList.push(_licenseRemind);
    return _dataList;
  },
  getAuditData(data, factorySystemClassRows = []) {
    const _dataList = [];
    const _auditSubclasses = {
      title: i18n.t('領域'),
      type: 'chip',
      chip: this.getMergedSubclassesForChip(data, factorySystemClassRows),
    };
    _dataList.push(_auditSubclasses);
    const _auditDate = {
      title: i18n.t('稽核日期'),
      type: 'text',
      textContent: time.getTimeFormat(data.payload.record_at, 'YYYY-MM-DD'),
    };
    _dataList.push(_auditDate);
    const _auditor = {
      title: i18n.t('稽核者'),
      type: 'avatars',
      avatars: [],
    };
    _auditor.avatars = [...data.payload.auditors];
    _dataList.push(_auditor);
    const _auditee = {
      title: i18n.t('受稽者'),
      type: 'avatars',
      avatars: [],
    };
    _auditee.avatars = [...data.payload.auditees];
    _dataList.push(_auditee);
    return _dataList;
  },
  async getAuditQues(data) {
    const recordId = data.payload.id;
    const _recordAnswers = await this.getAuditAnswer(recordId);
    const _questions = await this.getAuditQuesRecord(recordId);
    const chapterListRiskSort = [
      {
        score: null,
        categoryTitle: '未答題',
        leadingIcon: 'icon-help-filled',
        iconColor: '',
        questionList: [],
      },
      {
        score: 23,
        categoryTitle: 'Major(主要缺失)',
        leadingIcon: 'icon-info-filled',
        iconColor: 'red',
        questionList: [],
      },
      {
        score: 22,
        categoryTitle: 'Minor(次要缺失)',
        leadingIcon: 'icon-info-filled',
        iconColor: 'yellow',
        questionList: [],
      },
      {
        score: 21,
        categoryTitle: 'OFI(待改善)',
        leadingIcon: 'icon-info-filled',
        iconColor: 'blue',
        questionList: [],
      },
      {
        score: 25,
        categoryTitle: '合規',
        leadingIcon: 'icon-check-circle-filled',
        iconColor: 'green',
        questionList: [],
      },
      {
        score: 20,
        categoryTitle: '不適用',
        leadingIcon: 'icon-cancel',
        iconColor: '',
        questionList: [],
      },
    ];
    const chapters = S_auditRecord.getChaptersWithAnswers(
      _questions.chapters,
      _recordAnswers,
    ).filter(chapter => {
      let hasQuestion = false;
      chapter.sectionList = chapter.sectionList.filter(section => section.questionList.length);
      chapter.sectionList.forEach(section => {
        hasQuestion = section.questionList.length > 0;
      })
      return hasQuestion;
    });
    const listWithIndex = S_auditRecord.getCustomedIndex(chapters);
    const chapterList = JSON.parse(JSON.stringify(listWithIndex));
    const allQues = S_auditRequest.getAllQuesResult(chapterList);
    return S_auditRequest.getChapterRiskSort(chapterListRiskSort, allQues);
  },
  async getAuditAnswer(recordId) {
    const res = await S_auditRecord.answerIndex(recordId);
    return H_auditRecord.getRecordAnswers(res);
  },
  async getAuditQuesRecord(recordId) {
    const res = await S_auditRecord.show(recordId);
    return H_auditRecord.getRecordData(res);
  },
  setAlertContent(data) {
    if (data.from === 'event') {
      return {
        id: data.payload.id,
        title: '[' + data.payload.event_type.name + '] ' + data.payload.name,
        type: data.from,
        info: {
          title: i18n.t('警示說明'),
          content:
            `${i18n.t(data.payload.event_type.name)} ${i18n.t('已發生，請通知負責人盡快處理此事件。')}`,
        },
      };
    } else if (data.from === 'exit_checklist') {
      return {
        id: data.payload.id,
        title:
          `[${i18n.t('進場尚未復歸')}] ` +
          data.payload.contractor.name +
          '-' +
          data.payload.task_content,
        type: data.from,
        info: {
          title: i18n.t('警示說明'),
          content: i18n.t(
            '此進場作業尚未復歸，詢問相關負責人，瞭解收工檢查狀況。',
          ),
        },
      };
    } else if (data.from === 'contractor_enter_record') {
      const contractorName = data.payload.contractor
        ? data.payload.contractor.name
        : '';
      return {
        id: data.payload.id,
        enterAssignmentDate: time.getTimeFormat(data.created_at, 'YYYY-MM-DD'),
        title:
          `[${i18n.t('進場尚未檢查')}] ` +
          contractorName +
          '-' +
          data.payload.task_content,
        type: data.from,
        info: {
          title: i18n.t('警示說明'),
          content: i18n.t(
            '此進場作業尚未收工檢查，通知相關負責人盡快進行收工檢查。',
          ),
        },
      };
    } else if (data.from === 'contractor_license') {
      const contractorName = data.payload.contractor
        ? data.payload.contractor.name
        : '';
      return {
        alertId: data.id,
        contractorId: data.payload.contractor.id,
        id: data.payload.id,
        title:
          `[${i18n.t('承攬商資格到期')}] ` +
          contractorName +
          '-' +
          data.payload.name,
        type: data.from,
        info: {
          title: i18n.t('警示說明'),
          content: i18n.t(
            '此承攬商資格證已到期未辦理，通知相關負責人盡快辦理。',
          ),
        },
      };
    } else if (data.from === 'license') {
      if (data.type === 'valid_end_date') {
        return {
          //證照有效迄日當日
          id: data.payload.id,
          title: `[${i18n.t('證照到期')}] ` + data.payload.name,
          type: data.from,
          subType: data.type,
          info: {
            title: i18n.t('警示說明'),
            content: i18n.t('此證照已到期，通知相關負責人盡快辦理。'),
          },
        };
      } else if (data.type === 'remind_date') {
        return {
          //證照提醒日
          id: data.payload.id,
          title: `[${i18n.t('證照續辦提醒')}] ` + data.payload.name,
          type: data.from,
          subType: data.type,
          info: {
            title: i18n.t('警示說明'),
            content: i18n.t('此證照已屆續辦提醒，通知相關負責人盡快辦理。'),
          },
        };
      } else if (data.type === 'statitory_extension_period') {
        return {
          //其他證照
          id: data.payload.id,
          title: `[${i18n.t('證照法定展延期限')}] ` + data.payload.name,
          type: data.from,
          subType: data.type,
          info: {
            title: i18n.t('警示說明'),
            content: i18n.t('此證照已屆法定展延期限，通知相關負責人盡快辦理。'),
          },
        };
      } else {
        return {
          //其他證照
          id: data.payload.contractor.id,
          title: `[${i18n.t('證照法定展延期限')}] ` + data.payload.name,
          type: data.from,
          subType: data.type,
          info: {
            title: i18n.t('警示說明'),
            content: i18n.t('此證照已屆法定展延期限，通知相關負責人盡快辦理。'),
          },
        };
      }
    } else if (data.from === 'checklist_record') {
      const risk = this.getRecordResult(data.payload.risk_level);
      const passRate = data.payload.pass_rate;
      return {
        //點檢不合規
        id: data.payload.id,
        level: data.payload.risk_level,
        title: `[${i18n.t('點檢')}] ${data.payload.name} (${i18n.t(
          '平均合規率',
        )} ${passRate}%) ${i18n.t(
          '結果',
        )} - ${risk}`,
        type: data.from,
        info: {
          title: i18n.t('警示說明'),
          content: i18n.t('此點檢表結果為{risk}，平均合規率為{pass_rate}%，檢視以下異常題目，通知相關人員盡快改善不合規的部分。', { risk, pass_rate: passRate })
        },
      };
    } else if (data.from === 'audit_record') {
      return {
        //稽核不合規
        id: data.payload.id,
        level: data.payload.risk_level,
        title: `[${i18n.t('稽核')}] ${data.payload.name}
        ${i18n.t('結果')} - ${this.getRecordResult(data.payload.risk_level)}`,
        type: data.from,
        info: {
          title: i18n.t('警示說明'),
          content: i18n.t('此稽核表結果為{risk}，檢視以下異常題目，通知相關人員盡快改善不合規的部分。', { risk: this.getRecordResult(data.payload.risk_level) })
        },
      };
    } else return {};
  },
  setCardAmount(rawData) {
    const {
      level_1_count,
      level_2_count,
      unsolved_count,
      solved_count,
      total_count
    } = rawData;
    const cardList = [...Spare_alertIndexTable.cardList];
    cardList[0].num = level_2_count;
    cardList[1].num = level_1_count;
    cardList[2].num = H_common.getPercentage(
      unsolved_count,
      total_count
    );
    cardList[3].num = H_common.getPercentage(
      solved_count,
      total_count
    );
    return cardList;
  },
  setTabAmount(rawData) {
    const tabList = [...Spare_alertIndexTable.tabList];
    const {unsolved_count, solved_count, total_count} = rawData;
    tabList.forEach(tab => {
      tab.num = tab.id === '1'
        ? unsolved_count
        : tab.id === '2'
        ? solved_count
        : total_count;
    });
    return tabList;
  },
}
